import { FlexCell, VirtualList } from '@epam/promo';
import { VirtualListState } from '@epam/uui-core';
import { useEffect, useState } from 'react';

import { useAppLocation } from 'hooks/helpers';
import { taskRoutes } from 'router/taskRoutes';
import { useTaskStore } from 'store/task';
import { useTaskGroupsStore } from 'store/task-groups';
import { GroupItem } from '../GroupItem';
import css from './GroupList.module.scss';

export const GroupList = () => {
  const { isNotFound, isCreate } = useAppLocation(taskRoutes);
  const { draft: draftTask } = useTaskStore((state) => state);
  const { taskGroups } = useTaskGroupsStore((state) => state);
  const [state, setState] = useState<VirtualListState>({
    topIndex: 0,
    visibleCount: 20,
  });
  const [active, setActive] = useState(draftTask.taskGroupId);

  const activeGroupId = !isNotFound ? draftTask.taskGroupId : '';

  useEffect(() => {
    setActive(activeGroupId);
  }, [activeGroupId]);

  if (!taskGroups.length) {
    return <FlexCell cx="skeleton-loader" grow={1} />;
  }

  const visibleItems = taskGroups.slice(
    state.topIndex,
    (state.topIndex ?? 0) + (state.visibleCount ?? 0),
  );

  const visibleRows = visibleItems.map(({ name, id }) => (
    <GroupItem
      key={id}
      active={active}
      groupId={id}
      groupName={name}
      setActive={setActive}
    />
  ));

  return (
    <VirtualList
      cx={{
        [css.list]: !isCreate,
        [css.littleList]: isCreate,
      }}
      rawProps={{ 'data-testid': 'tasks-group-list' }}
      role="listbox"
      rows={visibleRows}
      rowsCount={taskGroups.length}
      value={state}
      onValueChange={setState}
    />
  );
};
